<script setup lang="ts">
import BaseAlert from './ui/BaseAlert.vue';
import { useAlertStore } from '@/stores/alertStore';

const store = useAlertStore();
</script>
<template>
  <div
    v-if="store.alerts.length"
    class="alerts-container"
  >
    <BaseAlert
      v-for="alert in store.alerts"
      :key="alert.id"
      :alert="alert"
      class="mb-2"
      max-width="400px"
      @close="store.removeAlert(alert.id)"
    />
  </div>
</template>
<style scoped lang="scss">
.alerts-container {
  position: fixed;
  top: 40px;
  right: 20px;
  width: 400px;
  z-index: 2500;
}
</style>
